import { normalizeDateOnly } from '../../../shared/dateOnly.mjs'

export function formatProfileCalendarDate(value, locale) {
  const date = normalizeDateOnly(value)
  if (!date) return null
  return new Intl.DateTimeFormat(locale, { day: '2-digit', month: 'short', year: 'numeric', timeZone: 'UTC' }).format(new Date(`${date}T00:00:00Z`))
}

const PROFILE_MEMBERSHIP_STATUSES = ['active', 'current', 'paused', 'approved', 'pending', 'pending-approval', 'on-hold', 'suspended', 'inactive', 'expired', 'cancelled', 'canceled', 'terminated', 'upcoming', 'superseded', 'lapsed', 'future']
export function localizeMembershipStatus(status, t) {
  const key = String(status || '').toLowerCase().replace(/[ _]+/g, '-')
  return t(PROFILE_MEMBERSHIP_STATUSES.includes(key) ? `profileOverview.statuses.${key}` : 'profileOverview.unavailable')
}
